import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_any_wrkrs_work_more_than_60_hours_in_total_regular_overtime'

export const dataPointDefinition = {
  retracedId: 'did_any_wrkrs_work_more_than_60_hours_in_total_regular_overtime',
  name: 'Did any workers work more than 60 hours in total (regular + overtime) within any given week?',
  description:
    'The intent of this question is to understand if any worker worked more than 60 hours per week in the facility within the assessment period. \r\r\n\r\r\nThe total number of hours includes work on weekly rest days and/or public holidays.\r\r\n\r\r\nFor example, if at least one worker worked more than 60 hours in total (regular + overtime) in a given week, answer Yes.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-7',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6750,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
